import { __require as requireBarcodes } from "./index113.js";
import { __require as requireMerge } from "./index114.js";
import { __require as requireLinearizeEncodings } from "./index115.js";
import { __require as requireFixOptions } from "./index116.js";
import { __require as requireGetRenderProperties } from "./index117.js";
import { __require as requireOptionsFromStrings } from "./index118.js";
import { __require as requireErrorHandler } from "./index119.js";
import { __require as requireExceptions } from "./index120.js";
import { __require as requireDefaults } from "./index121.js";
var JsBarcode_1;
var hasRequiredJsBarcode;
function requireJsBarcode() {
  if (hasRequiredJsBarcode) return JsBarcode_1;
  hasRequiredJsBarcode = 1;
  var _barcodes = requireBarcodes();
  var _barcodes2 = _interopRequireDefault(_barcodes);
  var _merge = requireMerge();
  var _merge2 = _interopRequireDefault(_merge);
  var _linearizeEncodings = requireLinearizeEncodings();
  var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);
  var _fixOptions = requireFixOptions();
  var _fixOptions2 = _interopRequireDefault(_fixOptions);
  var _getRenderProperties = requireGetRenderProperties();
  var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);
  var _optionsFromStrings = requireOptionsFromStrings();
  var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);
  var _ErrorHandler = requireErrorHandler();
  var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);
  var _exceptions = requireExceptions();
  var _defaults = requireDefaults();
  var _defaults2 = _interopRequireDefault(_defaults);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var API = function API2() {
  };
  var JsBarcode = function JsBarcode2(element, text, options) {
    var api = new API();
    if (typeof element === "undefined") {
      throw Error("No element to render on was provided.");
    }
    api._renderProperties = (0, _getRenderProperties2.default)(element);
    api._encodings = [];
    api._options = _defaults2.default;
    api._errorHandler = new _ErrorHandler2.default(api);
    if (typeof text !== "undefined") {
      options = options || {};
      if (!options.format) {
        options.format = autoSelectBarcode();
      }
      api.options(options)[options.format](text, options).render();
    }
    return api;
  };
  JsBarcode.getModule = function(name2) {
    return _barcodes2.default[name2];
  };
  for (var name in _barcodes2.default) {
    if (_barcodes2.default.hasOwnProperty(name)) {
      registerBarcode(_barcodes2.default, name);
    }
  }
  function registerBarcode(barcodes, name2) {
    API.prototype[name2] = API.prototype[name2.toUpperCase()] = API.prototype[name2.toLowerCase()] = function(text, options) {
      var api = this;
      return api._errorHandler.wrapBarcodeCall(function() {
        options.text = typeof options.text === "undefined" ? void 0 : "" + options.text;
        var newOptions = (0, _merge2.default)(api._options, options);
        newOptions = (0, _optionsFromStrings2.default)(newOptions);
        var Encoder = barcodes[name2];
        var encoded = encode(text, Encoder, newOptions);
        api._encodings.push(encoded);
        return api;
      });
    };
  }
  function encode(text, Encoder, options) {
    text = "" + text;
    var encoder = new Encoder(text, options);
    if (!encoder.valid()) {
      throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
    }
    var encoded = encoder.encode();
    encoded = (0, _linearizeEncodings2.default)(encoded);
    for (var i = 0; i < encoded.length; i++) {
      encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
    }
    return encoded;
  }
  function autoSelectBarcode() {
    if (_barcodes2.default["CODE128"]) {
      return "CODE128";
    }
    return Object.keys(_barcodes2.default)[0];
  }
  API.prototype.options = function(options) {
    this._options = (0, _merge2.default)(this._options, options);
    return this;
  };
  API.prototype.blank = function(size) {
    var zeroes = new Array(size + 1).join("0");
    this._encodings.push({ data: zeroes });
    return this;
  };
  API.prototype.init = function() {
    if (!this._renderProperties) {
      return;
    }
    if (!Array.isArray(this._renderProperties)) {
      this._renderProperties = [this._renderProperties];
    }
    var renderProperty;
    for (var i in this._renderProperties) {
      renderProperty = this._renderProperties[i];
      var options = (0, _merge2.default)(this._options, renderProperty.options);
      if (options.format == "auto") {
        options.format = autoSelectBarcode();
      }
      this._errorHandler.wrapBarcodeCall(function() {
        var text = options.value;
        var Encoder = _barcodes2.default[options.format.toUpperCase()];
        var encoded = encode(text, Encoder, options);
        render(renderProperty, encoded, options);
      });
    }
  };
  API.prototype.render = function() {
    if (!this._renderProperties) {
      throw new _exceptions.NoElementException();
    }
    if (Array.isArray(this._renderProperties)) {
      for (var i = 0; i < this._renderProperties.length; i++) {
        render(this._renderProperties[i], this._encodings, this._options);
      }
    } else {
      render(this._renderProperties, this._encodings, this._options);
    }
    return this;
  };
  API.prototype._defaults = _defaults2.default;
  function render(renderProperties, encodings, options) {
    encodings = (0, _linearizeEncodings2.default)(encodings);
    for (var i = 0; i < encodings.length; i++) {
      encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
      (0, _fixOptions2.default)(encodings[i].options);
    }
    (0, _fixOptions2.default)(options);
    var Renderer = renderProperties.renderer;
    var renderer = new Renderer(renderProperties.element, encodings, options);
    renderer.render();
    if (renderProperties.afterRender) {
      renderProperties.afterRender();
    }
  }
  if (typeof window !== "undefined") {
    window.JsBarcode = JsBarcode;
  }
  if (typeof jQuery !== "undefined") {
    jQuery.fn.JsBarcode = function(content, options) {
      var elementArray = [];
      jQuery(this).each(function() {
        elementArray.push(this);
      });
      return JsBarcode(elementArray, content, options);
    };
  }
  JsBarcode_1 = JsBarcode;
  return JsBarcode_1;
}
export {
  requireJsBarcode as __require
};
//# sourceMappingURL=index112.js.map
